const { default: styled } = require("styled-components");

export const Container = styled.div``;

export const Error = styled.p`
  font-size: 13px;
  color: #eb5959;
  text-align: center;
`;
